export default {
  setForm(state, newForm) {
    state.form = newForm;
  },
  setFormPagination(state, newPagination) {
    state.pagination = newPagination;
  },
  setPaginationTotal(state, total) {
    state.totalInvoices = total;
  },
  setPreInvoices(state, invoices) {
    state.invoices = invoices;
  },
  toggleLoading(state, isLoading = false) {
    state.loading = isLoading;
  },
  toggleLoadingExports(state, isLoading = false) {
    state.loadingExports = isLoading;
  },
  setFormInvoiceField(state, invoice) {
    const { id } = invoice || {};

    state.form.invoices[id] = {
      ...(state.form.invoices[id] ? state.form.invoices[id] : ({})),
      ...invoice,
    };
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-generation/store/mutations.js